import ArrowIconLeft from '../../../assets/arrow-thin-left.svg?react';
import ArrowIconRight from '../../../assets/arrow-thin-right.svg?react';
import ArrowIconDown from '../../../assets/chevronDown.svg?react';
import useMobileView from '../../../hooks/useMobileView';
import { IconButton } from '../atoms/IconButton';

type ArrowDirection = 'left' | 'right' | 'down' | 'up';

interface ArrowIconButtonProps {
	direction: ArrowDirection;
	onClick: () => void;
	className?: string;
	iconClassName?: string;
}

const iconButtonClasses = 'flex items-center justify-center';

export const ArrowIconButton = ({
	direction,
	onClick,
	className,
	iconClassName,
}: ArrowIconButtonProps) => {
	const isMobile = useMobileView(900);

	return (
		<IconButton
			className={`${className || ''} ${iconButtonClasses}`}
			onClick={onClick}
			icon={getIcon(direction, iconClassName || '', isMobile)}
		/>
	);
};

const getIcon = (
	direction: ArrowDirection,
	iconClassName: string,
	isMobile: boolean,
) => {
	switch (direction) {
		case 'down':
			if (!isMobile) {
				return <ArrowIconRight className={`${iconClassName} rotate-90`} />;
			}
			return <ArrowIconDown className={iconClassName} />;
		case 'up':
			return <ArrowIconDown className={`${iconClassName} rotate-180`} />;
		case 'left':
			return <ArrowIconLeft className={iconClassName} />;
		default:
			return <ArrowIconRight className={iconClassName} />;
	}
};
